import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';

@Component({
  selector: 'sub-filtro-periodo-tarefa',
  templateUrl: './periodo-tarefa.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatRadioModule,
    MatMenuModule,
  ],
})
export class PeriodoTarefaComponent implements OnInit {
  @Input('listaPeriodoTarefa') listaPeriodoTarefa: any = {};
  @Input('periodoSelecionado') periodoSelecionado: number = 0; // Período único selecionado
  @Output() atualizaFiltroPeriodoTarefa = new EventEmitter<{ periodo: number; newValue: boolean }>();

  ngOnInit(): void {
  }

  // Verifica se um período específico está selecionado
  isPeriodoSelecionado(periodoId: number): boolean {
    return this.periodoSelecionado === periodoId;
  }

  // Lida com clique em qualquer parte do item
  onItemClick(periodoId: number, event: Event): void {
    // Prevenir que o clique se propague e cause duplo disparo
    event.stopPropagation();
    
    // Verificar se o clique foi diretamente no radio button (evitar duplo disparo)
    const target = event.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.classList.contains('mat-radio-inner-circle')) {
      return; // Deixar o radio button lidar com o evento
    }
    
    // Simular clique no radio button - selecionar este período
    this.onPeriodoChange(periodoId);
  }

  // Lida com mudança de seleção de um período (radio button)
  onPeriodoChange(periodoId: number): void {
    // Para radio button, sempre emite true para o período selecionado
    this.atualizaFiltroPeriodoTarefa.emit({
      periodo: periodoId,
      newValue: true
    });
  }

  get periodosDisponiveis() {
    return this.listaPeriodoTarefa;
  }
}
